import "@babel/polyfill";
//import easydropdown from "easydropdown";

require('./bootstrap');

global.eventFire = function eventFire(el, etype) {
	if (el.fireEvent) {
		el.fireEvent('on' + etype);
	} else {
		var evObj = document.createEvent('Events');
		evObj.initEvent(etype, true, false);
		el.dispatchEvent(evObj);
	}
}

const region_options = {
	Europe: 'en-GB',
	US: 'en-US'
};

// IE SVG fix
if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
	require('svgxuse');
}

window.Vue = require('vue');
window.Vue.config.productionTip = false;

import store from './store/store'
import './core'
import numbro from 'numbro';
import moment from 'moment';

import * as klaro from 'klaro'
// import the accompanying CSS (requires style-loader)
import 'klaro/dist/klaro.css'
import Spinwheel from "./components/Spinwheel.vue";

// Social sharing
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

import { VueReCaptcha } from 'vue-recaptcha-v3'

// For more options see below
Vue.use(VueReCaptcha, { siteKey: process.env.MIX_RECAPTCHA_SITE_KEY })

// Locales
const jslocales = window.sharedData.jslocales;
global.current_locale = window.sharedData.locale;
global.current_currency = window.sharedData.jscurrency;

Vue.prototype.$__ = (key, default_value) => {
	try {
		return key.split('.').reduce((o,i) => o[i], jslocales)
	} catch (e) {
		return default_value ? default_value : key;
	}
};
global.jslocale = (key, default_value) => {
	try {
		return key.split('.').reduce((o,i) => o[i], jslocales)
	} catch (e) {
		return default_value ? default_value : key;
	}
};

const jssettings = window.sharedData.jssettings;
Vue.prototype.$s_ = (key, default_value) => {
	try {
		return key.split('.').reduce((o,i) => o[i], jssettings)
	} catch (e) {
		return default_value ? default_value : key;
	}
};

Vue.component('spinwheel', Spinwheel);
Vue.component('lupit-pagination', require('laravel-vue-pagination'));
Vue.component('lupit-herohomecarousel', require('./components/Gallery/HeroHomeCarousel').default);
Vue.component('lupit-ambassadorscarousel', require('./components/Gallery/AmbassadorsCarousel').default);
Vue.component('lupit-studioscarousel', require('./components/Gallery/StudiosCarousel').default);
Vue.component('lupit-staffcarousel', require('./components/Gallery/StaffCarousel').default);
Vue.component('lupit-testimonials-product-reviews-carousel', require('./components/Gallery/TestimonialsProductReviewsCarousel').default);
Vue.component('lupit-trustedbycarousel', require('./components/Gallery/TrustedByCarousel').default);
Vue.component('lupit-productgallery', require('./components/Gallery/ProductGallery').default);
Vue.component('lupit-cart', require('./components/Cart/CartHeader.vue').default);
Vue.component('lupit-checkout', require('./components/Cart/CartCheckout').default);
Vue.component('lupit-addtocart', require('./components/Cart/CartAdd').default);
Vue.component('lupit-supportform', require('./components/Form/SupportForm').default);
Vue.component('lupit-favorites', require('./components/Favourites').default);
Vue.component('lupit-review', require('./components/Review').default);
Vue.component('lupit-share', require('./components/Share').default);
Vue.component('lupit-popmessage', require('./components/PopMessage').default);
Vue.component('lupit-search', require('./components/Search').default);
Vue.component('lupit-favoriteslist', require('./components/Profile/FavoriteList').default);
Vue.component('lupit-orderhistory', require('./components/Profile/OrderHistory').default);
Vue.component('lupit-ordersingle', require('./components/Profile/OrderSingle').default);
Vue.component('lupit-affiliate', require('./components/Profile/Affiliate').default);
Vue.component('lupit-coupons', require('./components/Profile/Coupons').default);
Vue.component('lupit-banners', require('./components/Profile/Banners').default);
Vue.component('lupit-contact', require('./components/Form/ContactForm').default);
Vue.component('lupit-region', require('./components/Region').default);
Vue.component('lupit-languageswitcher', require('./components/LanguageSwitcher').default);
Vue.component('lupit-profile', require('./components/Profile/Form').default);
Vue.component('lupit-currency-selector', require('./components/CurrencySelector').default);

const components = {
	'lupit-eec-productlist' : 'ProductList',
	'lupit-eec-product' : 'ProductSingle',
	'lupit-eec-home' : 'Home',
	'lupit-eec-promotion' : 'Promotion',
}

for(const prop in components) {
	Vue.component(prop, require('./components/Eec/' + components[prop]).default);
}

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('MM/DD/YYYY')
	}
});

Vue.filter('formatCurrency', function(value, coupon_region) {
	if (value) {
		if (coupon_region != null) {
			numbro.setLanguage(region_options[coupon_region]);
		}
		//numbro.setLanguage(region_options[region]);
		return numbro(parseFloat(value)).formatCurrency();
		numbro.setLanguage(region_options[region]);
	}
});

import Loading from 'vue-loading-overlay';
Vue.use(Loading);

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

const options = {
	confirmButtonColor: '#E6007E',
	cancelButtonColor: '#ff7674'
}

Vue.use(VueSweetalert2, options)

Vue.prototype.$dateFormat = (date, format = 'DD.MM.YYYY HH:mm') => {
	return dayjs(date).format(format);
}
Vue.prototype.$numberFormat = (number, decimals, dec_point, thousands_point) => {

	if (number == null || !isFinite(number)) {
		throw new TypeError("number is not valid");
	}

	if (!decimals) {
		var len = number.toString().split('.').length;
		decimals = len > 1 ? len : 0;
	}

	if (!dec_point) {
		dec_point = '.';
	}

	if (!thousands_point) {
		thousands_point = ',';
	}

	number = parseFloat(number).toFixed(decimals);

	number = number.replace(".", dec_point);

	var splitNum = number.split(dec_point);
	splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
	number = splitNum.join(dec_point);

	return number;
}
Vue.prototype.$truncate = ((text, max) => text.substr(0,max-1)+(text.length>max?'&hellip;':''));

// Define a new component called button-counter
Vue.component('svg-use', {
	props: {
		icon: {
			type: String,
			required: true
		},
	},
	template: '<svg class="ticon"><use :xlink:href="\'/images/icons.svg#icon-\'+icon"></use></svg>'
})

const app = new Vue({
	store,
	el: '#app',
	methods: {
		toggleNoScroll(enable) {
			if (enable) {
				document.body.classList.add('no-scroll');
			} else {
				document.body.classList.remove('no-scroll');
			}
		}
	}
});
global.vm = app;

// TODO: MAKE THIS WORK INSIDE CORE.JS FILE (IT IS NOT WORKING NOW - SCROLL IS NOT DETECTED!!!)
var elements;
var windowHeight;

function init() {
	elements = document.querySelectorAll('.gr-element, .hero-pop__news-container, .section-newsletter');
	windowHeight = window.innerHeight;
}

function checkPosition() {
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		var positionFromTop = elements[i].getBoundingClientRect().top;

		if (positionFromTop - windowHeight <= 0) {
			element.classList.add('fade-in-element');
		}
	}
}

window.addEventListener('scroll', checkPosition);
window.addEventListener('resize', init);

init();
checkPosition();
